import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromMultiTermsAccordion from '../../reducers/multi-terms-accordion/multi-terms-accordion.reducer';
import {
  buildAccordionOrder,
  MultiAccordionId,
  MultiTermsAccordionState,
} from '../../reducers/multi-terms-accordion/multi-terms-accordion.reducer';
import {
  selectAllNonW8TrustGroups,
  selectDistinctNonW8EstateGroups,
} from '../transaction-state/transaction-state.selectors';

export const selectMultiTermsAccordionState =
  createFeatureSelector<fromMultiTermsAccordion.MultiTermsAccordionState>('multiTermsAccordion');

export const selectMultiAccordions = createSelector(
  selectMultiTermsAccordionState,
  fromMultiTermsAccordion.getMultiAccordions,
);

export const selectAreAllMultiAccordionsAccepted = createSelector(
  selectMultiTermsAccordionState,
  fromMultiTermsAccordion.getAreAllMultiAccordionsAccepted,
);

export const selectAccordionOrder = createSelector(
  selectAllNonW8TrustGroups,
  selectDistinctNonW8EstateGroups,
  (trustGroups, estateGroups): string[] =>
    buildAccordionOrder(trustGroups.length, estateGroups.length),
);

export const selectFirstUnacceptedMultiAccordionId = createSelector(
  selectMultiTermsAccordionState,
  selectAccordionOrder,
  (state, order): string | null =>
    fromMultiTermsAccordion.getFirstUnacceptedMultiAccordionId(state, order),
);

export const selectCanMultiAccordionBeOpened = (accordionId: string) =>
  createSelector(
    selectMultiTermsAccordionState,
    selectAccordionOrder,
    (state: MultiTermsAccordionState, order: string[]) =>
      fromMultiTermsAccordion.canMultiAccordionBeOpened(state, accordionId, order),
  );
